import React, {Component} from "react";
import {BrowserRouter as Router, Link} from 'react-router-dom'
import {connect} from "react-redux";
import {epaFetchData} from "../../../actions/epa";
import Loader from "../UI/Loader";

class EpaTable extends Component {

    componentDidMount() {
        this.props.fetchData("https://psytable-api.herokuapp.com/api/epa");
    }


    render() {
        return (
            <section className="epa-table">
                <div className="epa-table__inner">
                    <h2 className="epa-table__headline">The functional Table of Human Evolved Psychological
                        Adaptions</h2>
                    <div className="classification">
                        <div className="classification__item">
                            <ul className="epa">
                                <span className="epa__name">Class 1</span>
                                <Router>
                                    {
                                        this.props.epa.length === 0
                                            ? <Loader/>
                                            : this.props.epa.map((item, index) => {
                                                if (item.classification === '1') {
                                                    return <li key={index} className="epa__item">
                                                        <Link className="epa__href" to={`/dossier/${item._id}`}
                                                              target="_parent">
                                                            {item.abbreviation}
                                                        </Link>
                                                    </li>
                                                }
                                            })
                                    }
                                </Router>
                            </ul>
                        </div>
                        <div className="classification__item">
                            <ul className="epa">
                                <span className="epa__name">Class 2</span>
                                <Router>
                                    {
                                        this.props.epa.length === 0
                                            ? <Loader/>
                                            : this.props.epa.map((item, index) => {
                                                if (item.classification === '2') {
                                                    return <li key={index} className="epa__item">
                                                        <Link className="epa__href" to={`/dossier/${item._id}`}
                                                              target="_parent">
                                                            {item.abbreviation}
                                                        </Link>
                                                    </li>
                                                }
                                            })}
                                </Router>
                            </ul>
                        </div>
                        <div className="classification__item">
                            <ul className="epa">
                                <span className="epa__name">Class 3</span>
                                <Router>
                                    {
                                        this.props.epa.length === 0
                                            ? <Loader/>
                                            : this.props.epa.map((item, index) => {
                                                if (item.classification === '3') {
                                                    return <li key={index} className="epa__item">
                                                        <Link className="epa__href" to={`/dossier/${item._id}`}
                                                              target="_parent">
                                                            {item.abbreviation}
                                                        </Link>
                                                    </li>
                                                }
                                            })}
                                </Router>
                            </ul>
                        </div>
                        <div className="classification__item">
                            <ul className="epa">
                                <span className="epa__name">Class 4</span>
                                <Router>
                                    {
                                        this.props.epa.length === 0
                                            ? <Loader/>
                                            :this.props.epa.map((item, index) => {
                                        if (item.classification === '4') {
                                            return <li key={index} className="epa__item">
                                                <Link className="epa__href" to={`/dossier/${item._id}`}
                                                      target="_parent">
                                                    {item.abbreviation}
                                                </Link>
                                            </li>
                                        }
                                    })}
                                </Router>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        )

    }

}


const mapStateToProps = (state) => {
    return {
        epa: state.epa
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchData: url => dispatch(epaFetchData(url))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EpaTable);
